export default __webpack_public_path__ + "static/media/Belt of Vehement Thunder.4558bb92.jpg";